module.exports = __webpack_public_path__ + "fc08b34920d7cf03a556feac4a528369.png";